// src/services/ToastrService.js
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

class ToastrService {
    // Show success toast
    success(message, options = {}) {
        toast.dismiss(); // close previous toast
        toast.success(message, {
            autoClose: 3000,
            pauseOnHover: true,
            closeOnClick: true,
            ...options,
        });
    }

    // Show error toast
    error(message, options = {}) {
        toast.dismiss();
        toast.error(message, {
            autoClose: 3000,
            pauseOnHover: true,
            closeOnClick: true,
            ...options,
        });
    }

    // Show info toast
    info(message, options = {}) {
        toast.dismiss();
        toast.info(message, {
            autoClose: 3000,
            pauseOnHover: true,
            closeOnClick: true,
            ...options,
        });
    }

    // Show warning toast
    warning(message, options = {}) {
        toast.dismiss();
        toast.warning(message, {
            autoClose: 3000,
            pauseOnHover: true,
            closeOnClick: true,
            ...options,
        });
    }
}

// Export a singleton instance
export default new ToastrService();